/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType {
    Unspecified = 0,
    Steam = 1,
    Egs = 2,
    Google = 3,
    Facebook = 4,
    SteamOpenId = 5,
    Aw = 6,
    VkId = 7,
    AuthenticateWithExternalIdGameAccessToken = 100,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType(value: any): boolean {
    for (const key in FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType) {
        if (Object.prototype.hasOwnProperty.call(FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType, key)) {
            if (FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType[key as keyof typeof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType {
    return json as FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeToJSON(value?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType | null): any {
    return value as any;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType {
    return value as FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType;
}

